import type {
  Body as AddPendingSegmentBody,
  Success as AddPendingSegmentSuccess,
  PathParams as AddPendingSegmentPathParams,
} from "@memento/app/endpoints/segment/add-pending";
import { GetAccessTokenFn } from "src/contexts/AuthProvider";
import { Fetcher } from "src/libs/fetcher";
import { getAddPendingSegmentEndpointUrl } from "src/libs/api-endpoint-lib";

export async function addPendingSegment(
  getAccessToken: GetAccessTokenFn,
  { cardId }: AddPendingSegmentPathParams,
  body: AddPendingSegmentBody
): Promise<AddPendingSegmentSuccess> {
  const fetcher = Fetcher(getAccessToken);

  return fetcher(getAddPendingSegmentEndpointUrl(cardId), {
    method: "POST",
    body,
  });
}
